module.exports = __webpack_public_path__ + "img/icon_chip_04.71f09363.png";